import { createApiSlice } from "@common/common-slice/commonSlice";

// routes
import {
  CRUD_SKILL_COURSE_LEVEL,
  GET_SKILL_COURSE_LEVEL,
} from "@routes";

// ---------------------------------------------------------------------

const apiConfig = [
  {
    name: "createSkillProficiencyLevel",
    method: "post",
    url: CRUD_SKILL_COURSE_LEVEL,
    stateKey: "message",
  },
  {
    name: "getSkillProficiencyLevel",
    method: "get",
    url: GET_SKILL_COURSE_LEVEL,
    stateKey: "data",
  },
  {
    name: "updateSkillProficiencyLevel",
    method: "put",
    url: CRUD_SKILL_COURSE_LEVEL,
    stateKey: "message",
  },
  {
    name: "deleteSkillProficiencyLevel",
    method: "delete",
    url: CRUD_SKILL_COURSE_LEVEL,
    stateKey: "message",
  },
];

// ---------------------------------------------------------------------

const customReducers = {
  initialState: {
    detailsData: [],
    selectedProficiencyLevelData: {},
    generate: false,
    backlogLoading: false,
  },

  reducers: {
    skillProficiencyLevelSelect: (state, action) => {
      state.selectedProficiencyLevelData = action?.payload;
    },
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "skillProficiencyLevel",
  apiConfig,
  customReducers,
);

const skillProficiencyLevelSlice = slice;

export default skillProficiencyLevelSlice.reducer;

export const {
  createSkillProficiencyLevel,
  getSkillProficiencyLevel,
  updateSkillProficiencyLevel,
  deleteSkillProficiencyLevel,
} = thunks;

export const {
  skillProficiencyLevelSelect,rowSelect
} = actions;